<script>
	const Vue = require('vue');
	const { getOfflineUserContext } = require('utilities/offlineUtilities');
	const userContext = require('core/userContext');
	const routeContext = require('core/routeContext');
	const classService = require('services/classService');
	const accountService = require('services/accountService');
	const utilities = require('../../../utilities');
	const page = require('page');
	const _ = require('underscore');
	const Q = require('q');
	const model = require('model/model');
	const pubsub = require('events/pubsub');
	const logger = require('utilities/logger');
	const { getGenericGCAuthURL } = require('utilities/googleClassroomUtilities');

	module.exports = {
		components: {
			'validated-input': require('components/validated-input.vue').default,
			'validated-form': require('components/validated-form.vue').default,
			'load-mask': require('components/load-mask.vue').default,
			'bookbag-icon': require('components/svg/bookbag-icon.vue').default,
			'form-submitter': require('components/form-submitter.vue').default,
			'google-logo': require('components/svg/google-logo.vue').default
		},

		modelData: ['userContext', 'offlineMode', 'gcAddon'],

		data() {
			return {
				navigating: false,
				url: null,
				classCode: null,
				tempClassCode: null,
				className: null,
				studentRostered: null,
				token: null,
				studentName: null,
				students: null,
				filteredStudents: null,
				focusedStudent: undefined,
				userName: null,
				classes: null,
				name: null,
				activeClass: null,
				accountDisabled: false,
				offlineLoading: false,
				studentPassword: undefined,
				addClassForm: {},
				newStudentClassCodeForm: {}
			};
		},

		methods: {
			openTeacherLogin: function () {
				page('/');

				model.remove('loginChoice');

				setTimeout(function () {
					utilities.openModal('#teacher-login-modal');
				}, 10);
			},

			clearUser: function (e) {
				e.preventDefault();

				this.userName = this.studentName = null;
				this.focusInput();
			},

			setClassCode: function (classCode) {
				let promise;
				classCode = classCode || this.tempClassCode;

				if (routeContext.getQuery('type') === 'clever') {
					var self = this;

					promise = accountService
						.initializeCleverUser({
							token: self.token,
							classCode: classCode
						})
						.then(function (initializeResult) {
							userContext.initialize(
								_.extend(
									{
										type: 'clever'
									},
									initializeResult
								)
							);

							self.loginComplete(classCode);
						});
				} else {
					promise = this.checkClassCode(classCode);
				}

				return promise;
			},

			checkClassCode: function (classCode, noLogin) {
				if (classCode) {
					var self = this;

					classCode = classCode.toUpperCase(); // FIXME: temporary fix for WEBUI-701

					return classService
						.checkClass({
							cc: classCode
						})
						.then(function (result) {
							// Class code found, all is well
							self.className = result.n;
							self.classCode = classCode;
							self.studentRostered = result.rt === 'student';

							self.activeClass = result;

							if (result.rt === 'student') {
								if (self.token) {
									return accountService
										.initializeGoogleUser({
											token: self.token,
											classCode: classCode,
											gcAddon: !!self.gcAddon
										})
										.then(function (initializeResult) {
											if (!noLogin) {
												userContext.initialize(
													_.extend(
														{
															type: 'google'
														},
														initializeResult
													)
												);

												if (self.token) {
													/*accountService.revokeToken({
											token: self.token
										});*/
													model.set('localGCAccessToken', self.token);
												}

												self.loginComplete(classCode);
											} else {
												self.getClassList(self.token);
											}
										});
								} else {
									self.navigateToGoogleLogin(classCode);
								}
							} else if (result.rt === 'teacher') {
								return classService
									.getStudents({
										cc: classCode
									})
									.then(function (getStudentsResult) {
										var students = getStudentsResult.students;

										if (students) {
											var studentMap = {};

											students.forEach(function (s) {
												var tokens = s.displayName.split(' ');

												s.firstName = tokens[0];
												s.lastName = tokens.slice(1).join(' ');
												s.uid = s.username;
												s.nameId = `student-name-${tokens.join('-').toLowerCase()}`;

												studentMap[s.uid] = s;
											});

											var studentNames = utilities.unambiguousStudentLabels(students);

											for (var key in studentNames) {
												studentMap[key].displayName = studentNames[key];
											}

											students = utilities.sortObjects(students, 'displayName');

											self.students = self.filteredStudents = students;
											self.focusedStudent = undefined;

											self.focusInput();
										}
									});
							}
							return undefined;
						})
						.catch(err => {
							if (window.readworks.config.rwtesting) {
								logger.info('Invalid Class Code Promise Catch');
							}
							err.formError = {
								name: 'classCode',
								message: 'Unknown class code.'
							};
							throw err;
						});
				} else {
					return Q.reject();
				}
			},

			nameSearch(e) {
				const query = e.target.value.toLowerCase();

				if (query) {
					this.filteredStudents = this.students.filter(s => s.displayName.toLowerCase().includes(query));
				} else {
					this.filteredStudents = this.students;
				}

				this.focusedStudent = undefined;
			},

			handleNameNavigation(key) {
				const lastOptionIndex = this.filteredStudents.length - 1;
				const focusedStudent = this.focusedStudent;
				const focusedStudentIndex = this.filteredStudents.indexOf(focusedStudent);
				let targetIndex = 0;

				switch (key) {
					case 'ArrowDown':
						targetIndex = focusedStudentIndex < lastOptionIndex ? focusedStudentIndex + 1 : 0;
						break;
					case 'ArrowUp':
						targetIndex = focusedStudentIndex > 0 ? focusedStudentIndex - 1 : lastOptionIndex;
						break;
					case 'Home':
						targetIndex = 0;
						break;
					case 'End':
						targetIndex = lastOptionIndex;
						break;
				}

				if (targetIndex !== focusedStudentIndex) {
					const targetStudent = this.filteredStudents[targetIndex];
					this.focusedStudent = targetStudent;
					this.$refs.studentNameOption[targetIndex].scrollIntoView({
						block: 'nearest'
					});
				}
			},
			nameKeydown(event) {
				const { key } = event;
				const filteredStudents = this.filteredStudents;

				if (filteredStudents.length > 0) {
					const isNavigationKey = new Set(['ArrowUp', 'ArrowDown', 'Home', 'End']).has(key);

					if (isNavigationKey) {
						event.preventDefault();
						this.handleNameNavigation(key);
						return;
					}

					if (key === 'Enter' && this.focusedStudent) {
						event.preventDefault();
						const { username, displayName, accountDisabled } = this.focusedStudent;
						this.selectStudent(username, displayName, accountDisabled);
						return;
					}
				}
			},

			selectStudent(username, displayName, accountDisabled) {
				this.accountDisabled = accountDisabled;
				this.userName = username;
				this.studentName = displayName.split(' ')[0];
				this.focusInput();
			},

			/* eslint-disable consistent-return */
			signIn: function () {
				var self = this;
				var userName = this.userName;
				var password = this.studentPassword;
				var classCode = this.classCode;

				// some students are mysteriously trying to sign in with blank values. If that's
				// happening now, log it so we can learn more
				if (!('' + userName).trim() || !('' + password).trim() || !('' + classCode).trim()) {
					pubsub.publish('message-error', 'There was a technical issue please reload the page and try signing in again');
					logger.error('student user is trying to sign in with blank values');
					return;
				}

				return accountService
					.studentSignInNative({
						password: password,
						username: userName,
						classCode: classCode
					})
					.then(function (result) {
						userContext.initialize({
							uid: result.uid,
							token: result.token,
							username: userName,
							classCode: classCode,
							firstName: result.firstName || '',
							lastName: result.lastName || '',
							ell: result.ell || '',
							created: result.created,
							rmFont: result.rmFont
						});

						self.loginComplete(classCode);
					});
			},
			/* eslint-enable consistent-return */

			getClassList: function (token) {
				var self = this;

				if (routeContext.getQuery('type') === 'clever') {
					return classService
						.getClassesFromCleverToken({
							token: token
						})
						.then(
							function (results) {
								self.classes = utilities.sortObjects(results, 'n');
							},
							function (error) {
								page('/');
							}
						);
				} else {
					return classService
						.getClassesFromGoogleToken({
							token: token
						})
						.then(
							function (results) {
								const classes = utilities.sortObjects(results.classes, 'n');

								if (self.gcAddon) {
									const currentClass = classes.find(c => c.gcid === self.gcAddon.courseId);

									if (currentClass) {
										self.setClassCode(currentClass.cc);
									}
								}

								self.classes = classes;
							},
							function (error) {
								if (error.code === 1063) {
									self.navigateToGoogleLogin();
								} else if (error.code === 1064) {
									page('/');
								}
							}
						);
				}
			},

			addClass: function (data, cb) {
				var self = this,
					classCode = data.classCode;

				classService
					.checkClass({
						cc: classCode
					})
					.then(function (result) {
						if (result.rt === 'student') {
							accountService
								.initializeGoogleUser({
									token: self.token,
									classCode: classCode,
									gcAddon: !!self.gcAddon
								})
								.then(function (initializeGoogleUserResult) {
									userContext.setToken(initializeGoogleUserResult.token);

									self.getClassList(self.token);

									model.set('localGCAccessToken', self.token);

									utilities.closeModals();

									cb(null, initializeGoogleUserResult);
								})
								.fail(cb);
						} else if (result.rt === 'teacher') {
							utilities.openModal('#sr-tr-redirect');

							self.$subscribeOnce('modal-closed', function (modalId) {
								if (modalId === 'sr-tr-redirect') {
									self.checkClassCode(classCode);
									self.token = null;
								}
							});

							cb(new Error());
						}
					})
					.catch(cb);
			},

			loginComplete: function (classCode) {
				// After logging in, send user to where they actually wanted to go
				var redirectURL = routeContext.getQuery('url');

				if (!redirectURL) {
					redirectURL = '/student';
				}

				model.set('activeClass', this.activeClass);

				page.redirect(redirectURL);

				pubsub.publish('logged-in');
			},

			navigateToGoogleLogin: function (classCode = '') {
				if (!this.navigating) {
					document.location = getGenericGCAuthURL(
						new URLSearchParams({
							url: this.url,
							classCode
						})
					);

					this.navigating = true;
				}
			},

			checkForOfflineMode() {
				let offlineMode = this.offlineMode;
				this.offlineLoading = true;
				getOfflineUserContext()
					.then(uc => {
						if (offlineMode && uc && uc.token) {
							userContext.initialize(uc, true);
							page('/student');
						}
					})
					.finally(() => (this.offlineLoading = false));
			},

			postOfflineReady() {
				var self = this;
				let offlineMode = this.offlineMode;
				this.url = encodeURIComponent(routeContext.getQuery('url') || '/student');

				var token = routeContext.getQuery('token'),
					studentName = routeContext.getQuery('studentName'),
					userName = routeContext.getQuery('username'),
					name = routeContext.getQuery('name'),
					classCode = routeContext.getQuery('classCode');
				this.offlineLoading = false;
				if (offlineMode) {
					this.checkForOfflineMode();
				} else if (token) {
					if (token === 'access-denied') {
						pubsub.publish('message-error', "We're sorry, if you do not allow ReadWorks permission, you will not be able to login with Google.");
					} else if (token === 'access-error') {
						pubsub.publish('message-error', 'There was an issue logging you in with Google. Please try to log in again.');
					} else {
						this.token = token;

						model.set('localGCAccessToken', token);

						if (this.url.indexOf('google-token') !== -1) {
							window.close();

							return;
						}

						userContext.reset();

						this.getClassList(token).then(function () {
							if (!self.classes.length && !classCode) {
								utilities.openModal('#new-student-modal');
							}
						});
					}
				}

				if (studentName) {
					this.studentName = studentName;
				}

				if (userName) {
					this.userName = userName;
				}

				if (name) {
					this.name = name;
				}

				if (!offlineMode && classCode) {
					this.checkClassCode(classCode);
				}
			},
			onLoggedOut(evData) {
				this.className = null;
				this.classCode = null;
			},
			focusInput() {
				Vue.nextTick(() => {
					const target = this.$refs.focusTarget;
					if (target) {
						target.$el.focus();
					}
				});
			}
		},

		watch: {
			offlineMode(value) {
				if (typeof value !== 'undefined') {
					this.postOfflineReady();
				}
			}
		},

		mounted() {
			this.offlineLoading = true;

			pubsub.subscribe('logged-out', this.onLoggedOut);
		}
	};
</script>
<style lang="scss">
	@import 'config/colors';
	@import 'mixins/media';

	.student-authentication-wrapper {
		position: relative;

		.student-authentication {
			display: flex;
			justify-content: center;
		}

		.icon-container {
			display: none;
			background-color: $c-student-login;

			@include media(med) {
				flex: 0 1 20rem;
				display: flex;
				align-items: flex-start;
			}

			.bookbag-icon {
				width: 100%;
				height: auto;
			}
		}

		.login-container {
			flex: 0 1 30rem;
			padding: 2rem;
			background-color: $c-white;
			display: flex;
			flex-direction: column;
			text-align: center;

			@include media(med) {
				padding: 2rem 4rem;
			}
		}

		h1 {
			margin: 0 0 3rem;

			&.has-student-name {
				margin-bottom: 0;

				+ a {
					margin-bottom: 3rem;
				}
			}
		}

		label {
			text-align: left;
		}

		.login-or {
			margin-top: 2rem;
			font-size: 1.25rem;
			display: flex;
			justify-content: center;
			align-items: center;

			&:before,
			&:after {
				content: '';
				width: 1rem;
				border-bottom: 1px solid $c-slate;
			}

			&:before {
				margin-right: 0.35rem;
			}

			&:after {
				margin-left: 0.35rem;
			}
		}

		.not-a-student {
			margin-top: auto;
		}
	}
</style>
<template>
	<div class="student-authentication-wrapper">
		<load-mask v-if="typeof offlineMode === 'undefined' || offlineLoading"></load-mask>
		<main
			class="main"
			v-if="token">
			<header class="main-header">
				<div class="wrapper">
					<h1 class="main-header-title">My Classes</h1>
					<ul class="main-header-actions">
						<li v-if="!userContext || !userContext.organization">
							<button
								data-modal="#add-class"
								class="button -outline">
								+ Add a Class
							</button>
						</li>
					</ul>
				</div>
			</header>
			<div class="main-content wrapper">
				<div v-if="classes && classes.length != 0">
					<div>
						<div
							class="padding-medium"
							style="border-bottom: 1px solid #d6dfe0">
							<span class="text-muted"><strong>Class</strong></span>
							<span
								v-if="!userContext || !userContext.organization"
								class="text-muted text-right"
								style="float: right"
								><strong>Class Code</strong></span
							>
						</div>
						<div
							class="padding-medium"
							style="border-bottom: 1px solid #d6dfe0"
							v-for="clas in classes"
							:key="clas.cc">
							<span>
								<a
									href="#"
									@click.prevent
									v-progress-click="() => setClassCode(clas.cc)">
									<strong>{{ clas.n }}</strong>
								</a>
							</span>
							<span
								v-if="!userContext || !userContext.organization"
								class="text-muted text-right"
								style="float: right"
								>{{ clas.cc }}</span
							>
							<div>{{ clas.name }}</div>
						</div>
					</div>
				</div>
				<div v-if="classes && classes.length == 0">Please add a class.</div>
			</div>
		</main>
		<main
			v-if="!token"
			class="padding-top-bottom-large student-authentication">
			<div class="icon-container">
				<bookbag-icon></bookbag-icon>
			</div>
			<div class="login-container">
				<h1 v-if="!studentName">Student Login</h1>
				<template v-else>
					<h1
						v-if="studentName"
						class="has-student-name">
						Welcome, {{ studentName }}!
					</h1>
					<a
						class="font-small block text-centered text-bold clear-user-link"
						v-if="studentRostered == false"
						href="javascript:void(0)"
						@click="clearUser">
						I'm not {{ studentName }}
					</a>
				</template>
				<div class="content">
					<button
						v-if="!classCode || studentRostered == true"
						class="button -google -full-width"
						@click="navigateToGoogleLogin()">
						<google-logo></google-logo>
						<span>Sign in with Google</span>
					</button>
					<div v-if="!classCode">
						<div class="login-or text-muted">OR</div>
						<validated-form
							:on-submit="setClassCode"
							class="student-signin-form">
							<div class="input-wrapper">
								<validated-input
									type="text"
									id="student-class-code"
									class="class-code"
									pattern=".{6,6}"
									override-message="Please enter a valid class code."
									v-model.trim="tempClassCode"
									name="classCode"
									required></validated-input>
								<label
									for="student-class-code"
									class="class-code-label"
									placeholder="Class Code"></label>
							</div>
							<div class="input-wrapper submit-wrapper">
								<button
									type="submit"
									class="button submit -full-width -large">
									Continue
								</button>
							</div>
						</validated-form>
					</div>
					<div v-if="studentRostered == false">
						<validated-form v-if="!userName">
							<h2 class="margin-none">Select Your Name</h2>
							<validated-input
								class="padding-small"
								type="text"
								id="student-name-search"
								@input.native="nameSearch"
								@keydown.native="nameKeydown"
								role="combobox"
								aria-autocomplete="list"
								aria-expanded="true"
								aria-controls="student-selection-list"
								:aria-activedescendant="focusedStudent && focusedStudent.nameId"
								ref="focusTarget"></validated-input>
							<label
								for="student-name-search"
								placeholder="Search for your name"></label>
							<ul
								id="student-selection-list"
								class="student-selection"
								role="listbox"
								aria-label="Search for your name">
								<li
									class="font-medium padding-xs student-name-option"
									:class="{
										'error-text': s.accountDisabled
									}"
									@click="selectStudent(s.username, s.displayName, s.accountDisabled)"
									v-for="s in filteredStudents"
									:key="s.username"
									:id="s.nameId"
									role="option"
									:aria-selected="focusedStudent === s ? 'true' : null"
									ref="studentNameOption">
									{{ s.displayName }}
								</li>
							</ul>
						</validated-form>
						<div v-if="userName">
							<template v-if="accountDisabled"> Sorry, your account has been suspended. Please tell your teacher. </template>
							<template v-else>
								<validated-form
									class="form form-signin"
									:on-submit="signIn">
									<div class="input-wrapper">
										<validated-input
											type="password"
											id="student-password"
											class="class-code"
											pattern=".{4,}"
											maxlength="32"
											override-message="Passwords must be at least 4 characters."
											v-model.trim="studentPassword"
											name="student-password"
											required
											ref="focusTarget"></validated-input>
										<label
											for="student-password"
											placeholder="Password"></label>
									</div>
									<div class="input-wrapper submit-wrapper">
										<button
											type="submit"
											class="button submit -full-width">
											Continue
										</button>
									</div>
								</validated-form>
								<a
									v-if="activeClass.l !== true"
									:href="`/change-password?classCode=${classCode}&studentName=${studentName}&username=${userName}`"
									>Change Password</a
								>
							</template>
						</div>
					</div>
				</div>
				<div class="not-a-student text-muted">
					Not a student?
					<a
						href="#"
						@click.prevent="openTeacherLogin"
						>Go to the Teacher Login</a
					>
				</div>
			</div>
		</main>
		<div
			id="add-class"
			class="modal"
			data-modal-window>
			<div class="modal-container">
				<div class="modal-window">
					<div class="modal-window-wrap">
						<button
							class="modal-close"
							data-modal-close>
							<span aria-hidden="true">&times;</span><span class="hidden-visually"> Close</span>
						</button>
						<section class="modal-content">
							<header class="modal-content-header">
								<h2>Add a Class</h2>
							</header>
							<div class="modal-content-main">
								<form-submitter
									form-name="addClassForm"
									:form-data.sync="addClassForm"
									:submit-to="addClass"
									action="./"
									class="form"
									no-close-modal
									novalidate>
									<auto-form-row
										v-bind:data.sync="addClassForm.classCode"
										placeholder="Enter Class Code"
										row-class="labelHiddenVisually"
										type="classCode"
										required>
									</auto-form-row>
									<auto-form-row
										v-bind:all-valid="addClassForm.allValid"
										type="submit"
										row-class="-full-width">
										Continue
									</auto-form-row>
								</form-submitter>
							</div>
						</section>
					</div>
				</div>
			</div>
		</div>
		<div
			id="new-student-modal"
			class="modal"
			data-modal-window>
			<div class="modal-container">
				<div class="modal-window">
					<div class="modal-window-wrap">
						<button
							class="modal-close"
							data-modal-close>
							<span aria-hidden="true">&times;</span><span class="hidden-visually"> Close</span>
						</button>
						<section class="modal-content">
							<header class="modal-content-header">
								<h2>Welcome, {{ name }}</h2>
							</header>
							<div class="margin-bottom-smedium">Enter the class code your teacher gave you.</div>
							<div class="modal-content-main">
								<form-submitter
									form-name="newStudentClassCodeForm"
									:form-data.sync="newStudentClassCodeForm"
									:submit-to="addClass"
									action="./"
									class="form"
									no-close-modal
									novalidate>
									<auto-form-row
										v-bind:data.sync="newStudentClassCodeForm.classCode"
										placeholder="Enter Class Code"
										row-class="labelHiddenVisually"
										type="classCode"
										required>
									</auto-form-row>
									<auto-form-row
										v-bind:all-valid="newStudentClassCodeForm.allValid"
										type="submit"
										row-class="-full-width">
										Continue
									</auto-form-row>
								</form-submitter>
							</div>
						</section>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
